export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        name: value.name,
        days: value.days,
        weeks: value.weeks,
        months: value.months,
        years: value.years
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        name: value.name,
        days: value.days,
        weeks: value.weeks,
        months: value.months,
        years: value.years
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of ['id', 'name', 'days', 'weeks', 'months', 'years']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.systems = value.systems
    } else {
      state.current = {
        id: '',
        name: '',
        days: 0,
        weeks: 0,
        months: 0,
        years: 0,
        systems: []
      }
      state.update = {
        id: '',
        name: '',
        days: 0,
        weeks: 0,
        months: 0,
        years: 0
      }
    }
  },
  UPDATE_NAME (state, value) {
    state.update.name = value
  },
  UPDATE_DAYS (state, value) {
    state.update.days = value
  },
  UPDATE_WEEKS (state, value) {
    state.update.weeks = value
  },
  UPDATE_MONTHS (state, value) {
    state.update.months = value
  },
  UPDATE_YEARS (state, value) {
    state.update.years = value
  }
}
